// Padel accessories (rackets, shoes, equipment) may be sold at an individual price.
export const isAccessory = (item) => {
  const c = (item?.category || '').toLowerCase();
  if (c.includes('miet')) return false;
  return ['schläger', 'schlaeger', 'racket', 'schuh', 'zubehör', 'zubehor', 'equipment'].some(k => c.includes(k));
};
